export function CoreLengthWarningDirective () {
  
  function isEmpty(value) {
    if (value == null || value == NaN || value == undefined || value == "") return true;
    else return false;
  };

  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ctrl) {
      ctrl.$parsers.push(function(value) {
        if (isEmpty(value)) {
          ctrl.$lengthWarning = false;
          element.removeClass('ng-invalid-maxLength');
        }
        else if (value.length > parseInt(attrs.lengthWarning)) {
          ctrl.$lengthWarning = true;
          element.addClass('ng-invalid-maxLength');
        }
        else {
          ctrl.$lengthWarning = false;
          element.removeClass('ng-invalid-maxLength');
        }
        return value
      });

      ctrl.$formatters.push(function(value) {
    //convert data from model format to view format
    if (isEmpty(value)) return "";
    else return value
  });
    }
  }
}